import utils from 'utils';
export default function permissionOrgTree(httpRequest, $stateParams) {
  return {
    restrict: 'E',
    scope: {
      userType: '<',
      treeOptions: '<',
      showSelected: '&',
      pageType: '@',
      getInfo: '=',
    },
    template: `
                <div ng-show="userType=='0'|| pageType=='user'" class="col-sm-2" ng-class="{'tree-div-transation': showHover}" ng-mouseenter="showHover = true" ng-mouseleave="showHover = false">
                    <div jquery-scrollbar jquery-scrollbar-config="{height:919}">
                        <treecontrol class="tree-light" tree-model="orgTree" options="treeOptions" on-selection="election(node)" selected-node="defaultNode" expanded-nodes="expandedNodes">
                            <p class="et-ellipsis" title="{{ node.orgName }}">{{ node.orgName }}</p>
                        </treecontrol>
                    </div>
                </div>
            `,
    link(scope) {
      // 有缓存参数，从缓存中取orgId
      const orgOwnerShip = JSON.parse(localStorage.user_info).user.orgOwnership;
      if (JSON.parse(localStorage.user_info).org) {
        scope.parentOrgId = JSON.parse(localStorage.user_info).org.parentOrgId;
      }
      // 获取机构树数据 为admin传0非admin传当前机构id
      scope.userTypeOrgId = scope.userType ? orgOwnerShip : 0;
      // roleListCtrl
      function buildTree(list, rootId) {
        // 适配树组件数据结构
        function recursion(data, pid) {
          const result = [];
          let temp;
          for (const i in data) {
            if (data[i].parentOrgId == pid) {
              result.push(data[i]);
              temp = recursion(data, data[i].orgId);
              if (temp.length > 0) {
                data[i].children = temp;
              }
            }
          }
          return result;
        }
        return recursion(list, rootId);
      }

      function getExpandedNode(arr, expandedNodeResult = []) {
        if (!arr || Object.prototype.toString.call(arr).indexOf('Array') == -1)
          return;
        for (var i = 0; i < arr.length; i++) {
          if (arr[i].children && arr[i].children.length) {
            expandedNodeResult.push(arr[i]);
            // 全部展开node
            // getExpandedNode(arr[i].children, expandedNodeResult);
          }
        }
        return expandedNodeResult;
      }
      utils.loading('正在加载···');
      httpRequest.get_organization(scope.userTypeOrgId).then((res) => {
        const resVal = res.data.value;
        //   回写数据
        if (scope.getInfo) {
          scope.getInfo(resVal);
        }
        // 机构树
        if (scope.userType) {
          scope.orgTree = buildTree(resVal, scope.parentOrgId);
          // //过滤出平级数据
          scope.peerDataTree = peerDataHandle(resVal, scope.parentOrgId);
          // 处理存在orgTree和peerDataTree有相同的数据 如果有
          if (scope.peerDataTree.length > 0) {
            scope.orgTree = handlerSameData(
              scope.orgTree,
              scope.peerDataTree[0].orgId
            );
          }
        } else {
          scope.orgTree = buildTree(resVal, -1);
        }
        scope.pageType === 'role' &&
          scope.orgTree.unshift({
            orgId: -2,
            orgName: '全部机构',
            parentOrgId: -1,
            treeLevelCode: '0',
            children: [],
          });
        if (scope.pageType === 'user' && scope.userType == '0') {
          scope.orgTree.unshift({
            orgId: '',
            orgName: '全部机构',
            parentOrgId: -1,
            children: [],
          });
        }
        scope.pageType === 'role' &&
          (scope.defaultNode = sessionStorage.rolePageOrg
            ? JSON.parse(sessionStorage.rolePageOrg)
            : scope.orgTree[0]);
        scope.pageType === 'department' &&
          (scope.defaultNode = scope.orgTree[0]);
        scope.pageType === 'user' && (scope.defaultNode = scope.orgTree[0]);
        console.log(decodeURI($stateParams.search));
        scope.expandedNodes = getExpandedNode(scope.orgTree);
        if (scope.pageType === 'user' && $stateParams.search) {
          for (var i = 0; i < resVal.length; i++) {
            if (
              resVal[i].orgId ==
              JSON.parse(decodeURI($stateParams.search)).orgIdList[0]
            ) {
              scope.defaultNode = resVal[i];
              break;
            }
          }
        }

        scope.pageType === 'role' &&
          scope.showSelected &&
          scope.showSelected({ node: scope.defaultNode });
        scope.pageType === 'department' &&
          scope.showSelected &&
          scope.showSelected({ node: scope.defaultNode });
        scope.pageType === 'user' &&
          scope.showSelected({ node: scope.defaultNode, flag: true });
      });
      // 返回平级数据树
      function peerDataHandle(arrList, currentPOrgId) {
        let peerDataList = arrList.filter((item) => {
          return item.notTreeStructure == false;
        });
        if (peerDataList.length == arrList.length) {
          return [];
        } else {
          let treeLevelCode = peerDataList[0].treeLevelCode;
          let treeLevelArr = treeLevelCode.split('_').map(Number);
          let parentOrgIdArr = treeLevelArr.filter((item, index) => {
            return item !== 0;
          });
          let peerDataTree = buildTree(peerDataList, parentOrgIdArr[0]);
          return peerDataTree;
        }
      }
      // 判断是否有重复数据
      function handlerSameData(allOrgTree, peerDataTreeOrgId) {
        if (allOrgTree[0].hasOwnProperty('children')) {
          recursionChild(
            allOrgTree,
            peerDataTreeOrgId,
            (item, peerDataTreeOrgId) => {
              if (item.orgId == peerDataTreeOrgId) {
                scope.newTree = allOrgTree;
              }
            }
          );
        } else {
          scope.newTree = allOrgTree.concat(scope.peerDataTree);
        }
        return scope.newTree;
      }
      // 递归树
      var recursionChild = function (allOrgTree, peerDataTreeOrgId, cb) {
        for (const i in allOrgTree) {
          cb(allOrgTree[i], peerDataTreeOrgId);
          if (allOrgTree[i].children) {
            recursionChild(allOrgTree[i].children, peerDataTreeOrgId, cb);
          }
        }
      };
      scope.showHover = false;
      scope.election = function (node) {
        scope.pageType === 'role' &&
          scope.showSelected &&
          scope.showSelected({ node });
        scope.pageType === 'department' &&
          scope.showSelected &&
          scope.showSelected({ node });
        scope.pageType === 'user' && scope.showSelected({ node, flag: true });
      };
    },
  };
}

permissionOrgTree.$inject = ['httpRequest', '$stateParams'];



// WEBPACK FOOTER //
// ./src/components/permissionOrgTree/permissionOrgTree.js